import { render, staticRenderFns } from "./ReviewDelete.vue?vue&type=template&id=f14bdad0"
import script from "./ReviewDelete.vue?vue&type=script&lang=js"
export * from "./ReviewDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports